<div>
  <ng-container class="mx-auto pt-[22px] px-[1.25rem] h-[calc(100%-100px)]">
    <nx-pageTitle-box class="mb-3" [label]="'Vorgänge'" [icon]="'icon-protocol-2'" [iconToolTip]="'Vorgänge'"
    [bcRootLvlLabel]="'Einstellungen'"
    [bcRootLvlPath]="'settings'">
    </nx-pageTitle-box>
  </ng-container>

    <div class="body">
      <p-tabView [scrollable]="true">
        <p-tabPanel [header]="'Vorgangstypen'">
          <div class="mt-[1.25rem]">
            <app-issue-types/>
          </div>
        </p-tabPanel>
        <p-tabPanel [header]="'Status Gruppen'">
          <div class="mt-[1.25rem]">
            <app-issue-status-groups/>
          </div>
        </p-tabPanel>
    </p-tabView>
    </div>
</div>
